import React, { createContext, useContext, useReducer } from 'react';
import dayjs from "dayjs";
import { useLocation } from "react-router-dom";

export const DEFAULT_SLICE_SECS = 86400;

export const daysToSlices = (sliceSecs, startDate, endDate) => {
  const startOfSlice = sliceSecs < 86400 ? 'hour' : 'day';
  let dateCounter = dayjs(startDate).startOf(startOfSlice);
  const startDateObj = dayjs(dateCounter);
  const endDateObj = dayjs(endDate).endOf(startOfSlice);
  const startSlice = Math.floor(dateCounter.valueOf() / 1000 / sliceSecs);
  const endSlice = Math.floor(endDate.valueOf() / 1000 / sliceSecs) + 1;
  return {
    startDateObj, endDateObj, startSlice, endSlice, dateCounter, startOfSlice
  };
}

const ReportDateContext = createContext(undefined);
export const ReportDateProvider = ({
  initialStartDate,
  initialEndDate,
  initialSliceSecs,
  children, reportId, title, isThreshold, language, chartConfig,
  createXlsCallback
}) => {
  const today = new dayjs();
  const reduceDateFrame = (state, { startDate, endDate, sliceSecs }) => {

    let dayList = [];
    let {
      startDateObj,
      endDateObj,
      startSlice,
      endSlice,
      dateCounter,
      startOfSlice
    } = daysToSlices(sliceSecs, startDate, endDate);

    while (dateCounter <= endDate) {
      dayList.push(dateCounter.toDate());
      dateCounter = dateCounter.add(1, startOfSlice);
    }
    const numberOfDays = endDateObj.diff(startDateObj, startOfSlice);

    return {
      startDate: startDateObj.toDate(),
      endDate: endDateObj.toDate(),
      startSlice,
      endSlice,
      dayList,
      numberOfDays,
      startTS: +startDateObj,
      sliceSecs,
      chartConfig,
      createXlsCallback,
    };
  };

  const { search } = useLocation();
  const params = new URLSearchParams(search);

  for (const [i, value] of params) {
    if (!i) {
      continue;
    }
    if (i === "start") {
      initialStartDate = new Date(value);

      continue;
    }
    if (i === "end") {
      initialEndDate = new Date(value);
      continue;
    }

    if (i === "id") {
      reportId = decodeURIComponent(value);
    }
    if (i === "isThreshold") {
      isThreshold = value === 'true';
    }
    if (i === "title") {
      title = decodeURIComponent(value);
    }
  }

  const [state, dispatch] = useReducer(reduceDateFrame, {
    startDate: initialStartDate || today.startOf('month').toDate(),
    endDate: initialEndDate || today.endOf('day').toDate(),
    sliceSecs: initialSliceSecs || DEFAULT_SLICE_SECS,
  }, reduceDateFrame.bind(undefined, undefined));

  return (
      <ReportDateContext.Provider
          value={{
            dispatch,
            state,
            reportId,
            isThreshold,
            title,
            language,
            chartConfig,
            createXlsCallback
          }}>
        {children}
      </ReportDateContext.Provider>
  )
}

export const useReportDateContext = () => {
  const {
    state,
    dispatch,
    reportId,
    isThreshold,
    title,
    language,
    chartConfig,
    createXlsCallback,
  } = useContext(ReportDateContext)
  return {
    state,
    dispatch,
    reportId,
    isThreshold,
    title,
    language,
    chartConfig,
    createXlsCallback
  }
}
